export const inactiveOrgEntityConfig = {
    entityType: 'organizations',
    entityCatalogueConfig: {
        filterConfig: {
            operator: 'lte',
            operand: 'ttm',
            filterLimit: 0,
        },
        constants: {},
    },
    entityDashboardConfig: {
        constants: {},
        isSavePDFEnabled: false,
    },
};
